export function enumToArray<T extends Record<string, string | number>>(
  enumObj: T,
  exclude: (string | number)[] = []
): T[keyof T][] {
  return Object.keys(enumObj)
    .filter(key => isNaN(Number(key)))
    .map(key => enumObj[key])
    .filter(value => !exclude.includes(value)) as T[keyof T][];
}
